<app-accordion-default
  titulo="Dados biopsicossociais"
  [isOpen]="panelOpenState"
  [lista]="bioPsicossocial"
></app-accordion-default>
<div class="spacer" style="height: 1em"></div>

<!---->
<mat-accordion>
  <mat-expansion-panel hideToggle style="pointer-events: none">
    <mat-expansion-panel-header>
      <mat-panel-title class="accordion-title">
        @if (imc() < 18.5) {
          <img src="../../../../../assets/svg/icons/eva_moderada_ic.svg" alt=""/>
        } @else if (imc() < 25) {
          <img src="../../../../../assets/svg/icons/eva_moderada_ic.svg" alt=""/>
        } @else if (imc() < 30) {
          <img src="../../../../../assets/svg/icons/eva_moderada_ic.svg" alt=""/>
        } @else if (imc() < 35) {
          <img src="../../../../../assets/svg/icons/eva_moderada_ic.svg" alt=""/>
        } @else if (imc() < 40) {
          <img src="../../../../../assets/svg/icons/eva_moderada_ic.svg" alt=""/>
        } @else {
          <img src="../../../../../assets/svg/icons/eva_moderada_ic.svg" alt=""/>
        } Resultado do IMC: {{ imc() }}
        <br/>
        @if (imc() < 18.5) {
          Indica baixo peso e pode estar associado a riscos
            nutricionais.
        } @else if (imc() < 25) {
          Indica peso adequado, com baixo
            risco de comorbidades associadas.
        } @else if (imc() < 30) {
          Indica
            sobrepeso e aumento do risco para o desenvolvimento de comorbidades.
        } @else if (imc() < 35) {
          Indica obesidade grau I e risco moderado de
            desenvolvimento de comorbidades associadas.
        } @else if (imc() < 40) {
          Indica obesidade grau II e o risco de desenvolvimento de comorbidades
            associadas é elevado.
        } @else {
          Indica obesidade grau III e o risco de
            desenvolvimento de comorbidades associadas é muito elevado.
        }
      </mat-panel-title>
    </mat-expansion-panel-header>
  </mat-expansion-panel>
</mat-accordion>

<div class="spacer" style="height: 1em"></div>

<app-accordion-default
  titulo="Hábitos alimentares"
  [isOpen]="panelOpenState"
  [lista]="habitosAlimentares"
></app-accordion-default>
<div class="spacer" style="height: 1em"></div>

<app-accordion-default
  titulo="Atividades físicas"
  [isOpen]="panelOpenState"
  [lista]="atividadesFisicas"
></app-accordion-default>
<div class="spacer" style="height: 1em"></div>

<app-accordion-default
  titulo="Aspectos psicoemocionais"
  [isOpen]="panelOpenState"
  [lista]="aspectosPsicoemocionais"
></app-accordion-default>
<div class="spacer" style="height: 1em"></div>

<app-accordion-default
  titulo="Impacto laboral"
  [isOpen]="panelOpenState"
  [lista]="impactoLaboral"
></app-accordion-default>
<div class="spacer" style="height: 1em"></div>

<mat-accordion>
  <mat-expansion-panel hideToggle style="pointer-events: none">
    <mat-expansion-panel-header>
      <mat-panel-title class="accordion-title">
        <!-- TODO: Definir as escalas para os icones -->
        @if (risco().toLowerCase().includes('mínimo risco')) {
          <img src="../../../../../assets/svg/icons/eva_baixa_ic.svg" alt=""/>
        }

        @else if (risco().toLowerCase().includes('baixo risco')) {
          <img src="../../../../../assets/svg/icons/eva_baixa_ic.svg" alt=""/>
        }

        @else if (risco().toLowerCase().includes('risco moderado')) {
          <img src="../../../../../assets/svg/icons/eva_moderada_ic.svg" alt=""/>
        }

        @else if (risco().toLowerCase().includes('alto risco')) {
          <img src="../../../../../assets/svg/icons/eva_moderada_ic.svg" alt=""/>
        }

        @else {
          <img src="../../../../../assets/svg/icons/eva_baixa_ic.svg" alt=""/>
        }

        {{ risco() }}

      </mat-panel-title>
    </mat-expansion-panel-header>
  </mat-expansion-panel>
</mat-accordion>
<div class="spacer" style="height: 1em"></div>

<app-accordion-default
  titulo="Transteórico"
  [isOpen]="panelOpenState"
  [lista]="transteorico"
></app-accordion-default>
<div class="spacer" style="height: 1em"></div>

<app-accordion-default
  titulo="Finalização"
  [isOpen]="panelOpenState"
  [lista]="finalizacao"
></app-accordion-default>
<div class="spacer" style="height: 1em"></div>
